import { Directive } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[appCheckSpace]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CheckSpaceDirective, multi: true }]
})
export class CheckSpaceDirective implements Validator {

  validate(control: AbstractControl) {
    if (/\s/.test(control.value)) {
      return { isNumber: true };
    }

    return null;
  }

}
